import centralBankLicense from '../../assets/files/en/license_en.pdf';
import pciDSSCertified from '../../assets/files/en/Certificate_PCI_DSS_LLC_2026.pdf';
import pdProtection from '../../assets/files/en/personal_data_processing_policy.pdf';
import W_8BEN_E from '../../assets/files/en/W-8BEN-E.pdf';
import W_8IMY from '../../assets/files/en/W-8IMY.pdf';
import glossary from '../../assets/files/en/Glossary.pdf';
import {
    BANK_ADDRESS_EN,
    BANK_BIK,
    BANK_CORR_ACC,
    BANK_INN_KPP,
    BANK_OGRN,
    BANK_PHONE
} from '../../constants';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

export default {
    seo: {
        title: 'Bank Details | Bank 131',
        description: 'Our bank details'
    },

    // Необходимо для рендеринга контента
    variantContent: {
        requisite: 'requisite',
        offices: 'offices',
        bankManagement: 'bankManagement',
        centralBankLicense: 'centralBankLicense',
        pciDSSCertified: 'pciDSSCertified',
        pdProtection: 'pdProtection',
        fatcaCompliance: 'fatcaCompliance',
        crsCompliance: 'crsCompliance',
        2021: '2021f',
        2020: '2020',
        2019: '2019',
        osms2020Report: 'osms2020Report',
        bpa: 'bpa',
        importantUpdates: 'importantUpdates',
    },

    content: {
        requisite: {
            rectangle: [
                {
                    title: 'FULL NAME IN RUSSIAN',
                    description: 'Акционерное общество «Bank 131»'
                },
                {
                    title: 'ABBREVIATED NAME IN RUSSIAN',
                    description: 'AO «Банк 131»'
                },
                {
                    title: 'FULL NAME IN IN ENGLISH',
                    description: 'Bank 131 Joint Stock Company'
                },
                {
                    title: 'ABBREVIATED NAME IN ENGLISH',
                    description: 'Bank 131 JSC'
                },
                {
                    title: 'LEGAL ADDRESS',
                    description: BANK_ADDRESS_EN
                },
                {
                    title: 'MAILING ADDRESS',
                    description: BANK_ADDRESS_EN
                },
                {
                    title: 'THE ACTUAL ADDRESS',
                    description: BANK_ADDRESS_EN
                },
                {
                    title: 'LICENSE REGISTRATION NUMBER',
                    description: '3538'
                },
                {
                    title: 'LICENSE',
                    description: 'The basic license for banking operations in rubles and foreign currency ' +
                        '(with the right to attract deposits from individuals) and for banking operations ' +
                        'with precious metals No. 3538 dated 11/29/2024.'
                },
                {
                    title: 'AUTHORIZED CAPITAL OF THE BANK',
                    description: '340 000 000 rubles'
                },
                {
                    title: 'PARTICIPATION IN THE MANDATORY DEPOSIT INSURANCE SYSTEM',
                    description: 'Not'
                },
                {
                    title: 'TIN / RRC',
                    description: BANK_INN_KPP
                },
                {
                    title: 'STATE REGISTRATION NUMBER',
                    description: BANK_OGRN
                },
                {
                    title: 'SRN ASSIGNMENT DATE',
                    description: 'November 29, 2024'
                },
                {
                    title: 'CORRESPONDENT ACCOUNT',
                    description: `${BANK_CORR_ACC} open in the Transaction and Cash Center No. 6 of ` +
                        'the Volga-Vyatka Main Directorate of the Central Bank of the Russian Federation'
                },
                {
                    title: 'BIC',
                    description: BANK_BIK
                },
                {
                    title: 'NATIONAL CLASSIFIERS IN STATISTICAL REGISTER',
                    description: 'OKPO 58583325 OKATO 92401367000 <br/>' +
                        'OKTMO 92701000001 OKOGU 4210014<br/>' +
                        'OKFS 16 OKOPF 12267<br/>' +
                        'OKVED 64.19 Other monetary intermediation'
                },
                {
                    title: 'OFFICIAL BANK WEBSITE',
                    description: 'www.131.ru'
                },
                {
                    title: 'E-MAIL',
                    description: 'help@131.ru'
                },
                {
                    title: 'TELEPHONE',
                    description: formatPhoneNumber(BANK_PHONE)
                },
                {
                    title: 'OPERATING HOURS',
                    description: 'Monday - Friday: from 09:00 to 18:00 (lunch from 13:00 to 14:00, Moscow time);<br/>' +
                        'Saturday - Sunday: days off (non-working) days.'
                },
            ],
            description: 'All information posted on the website is provided for general information only and is not a public offer.<br/>' +
                '<br/>' +
                'Person responsible for the completeness, accuracy and relevance of the information published on the Web site: Elena Eroshina, press@131.ru<br/>' +
                '<br/>' +
                'Supervision of the activities of Bank 131 JSC, reg. No. 3538: credit institution (Bank 131 JSC) activities supervision is carried out by the Bank of Russia Current Banking Supervision Service.<br/>' +
                '<br/>' +
                'Central Bank of the Russian Federation contact details: 107016, Moscow, st. Neglinnaya, 12, tel. 8-800-250-4072, 8-495-771-9100.<br/>' +
                '<br/>' +
                'Compliance supervision of the Russian Federation legislation in the field of protection of the financial services consumers rights is carried out by the Consumer Rights Protection and the Bank of Russia Financial Services Availability Service.<br/>' +
                '<br/>' +
                'A complaint about Russian Federation legislation’s violation made by the credit institution’s actions (inactions), as well as about the rights and interests of individuals or legal entities protected by law, can be sent to the Bank of Russia for consideration through an Internet reception (www.cbr.ru/Internet reception)<br/>' +
                '<br/>' +
                'All information posted on this website is provided for general information only and is not a public offer. The information that is currently not available will appear soon and we will add it to the site.'
        },
        centralBankLicense: [
            {
                label: 'Posting date 09.08.2019',
                title: 'License of the Central Bank of the Russian Federation No. 3538 dated April 12, 2019.PDF',
                link: centralBankLicense
            },
            {
                label: 'Posting date 26.01.2021',
                title: 'QR License of the Central Bank of the Russian Federation No 3538.pdf',
                link: '/legal/en/QR_License_of_the_Central_Bank_of_the_Russian_Federation_No_3538.pdf'
            }
        ],
        pciDSSCertified: [
            {
                label: 'Posting date 19.08.2026',
                title: 'Certificate PCI DSS.PDF',
                link: pciDSSCertified
            }
        ],
        pdProtection: [
            {
                label: 'Posting date 15.04.2021',
                title: 'Bank 131 JSC Personal Data Processing Policy.PDF',
                link: pdProtection
            }
        ],
        2021: [
            {
                label: 'Posting date 11.11.2021',
                title: 'Published reports for 9 months of 2021.zip',
                link: '/legal/en/Published_reports_for_9_months_of_2021.zip',
            },
            {
                label: 'Posting date 11.08.2021',
                title: 'Published reports for the first half of 2021.zip',
                link: '/legal/en/Published_reports_for_the_first_half_of_2021.zip',
            },
            {
                label: 'Posting date 14.05.2021',
                title: 'Published reports for the first quarter of 2021.zip',
                link: '/legal/en/Published_reports_for_the_first_quarter_of_2021.zip',
                clarification: {
                    label: 'Posting date 21.04.2021',
                    text: 'The annual shareholder meeting (Bank 131 Limited Liability Company`s sole shareholder decision) was held on April 16, 2021.'
                }
            }
        ],
        2020: [
            {
                label: 'Posting date 04.03.2021',
                title: 'Annual accounting (financial) statements for 2020.zip',
                link: '/legal/en/Annual_accounting_(financial)_statements_for_2020_en.zip',
            },
            {
                label: 'Posting date 12.11.2020',
                title: 'Published reports for 9 months of 2020.zip',
                link: '/legal/en/Published_reports_for_9_months_of_2020.zip',
            },
            {
                label: 'Posting date 10.08.2020',
                title: 'Published reports for first half of 2020.zip',
                link: '/legal/en/Published_reports_for_first_half_of_2020.zip',
            },
            {
                label: 'Posting date 18.05.2020',
                title: 'Published financial statements for the first quarter of 2020.zip',
                link: '/legal/en/1_kvartal_2020_en.zip',
                clarification: {
                    label: 'Posting date 29.04.2020',
                    text: 'Annual shareholder meeting (Bank 131 Limited Liability Company`s sole shareholder decision) was held on April 27, 2020.'
                }
            }
        ],
        2019: [
            {
                label: 'Posting date 03.03.2020',
                title: 'Annual accounting (financial) statements for 2019.zip',
                link: '/legal/en/Annual_accounting_statements_for_2019_en.zip',
            },
            {
                title: 'Auditor\'s report on the annual accounting (financial) statements for 2019.docx',
                link: '/legal/en/Audit_2019_en_Auditor_s_Report_2019.docx',
            },
            {
                label: 'Posting date 07.11.2019',
                title: 'Published reports for 9 months of 2019.zip',
                link: '/legal/en/Explanatory_information_01_10_2019_en.zip',
            },
            {
                label: 'Posting date 09.08.2019',
                title: 'Published reports for first half of 2019.zip',
                link: '/legal/en/First_half_of_2019_en.zip',
            }
        ],
        osms2020Report: [
            {
                label: 'Posting date 18.05.2020',
                title: 'OSMS 2020 Report.pdf',
                link: '/legal/en/special_assessment_of_working_conditions_en_2020.docx',
            }
        ],
        fatcaCompliance: {
            information: 'Bank 131 JSC hereby informs you that, per Federal Law of Russia No. 173-FZ dd. ' +
                'June 28, 2014 "On the specifics of performing financial transactions with foreign citizens and ' +
                'legal entities; on the changes to the Code of the Russian Federation on Administrative ' +
                'Offenses and repeal of several provisions of Russian legislation" and Foreign Account Tax ' +
                'Compliance Act (FATCA, US Federal Law), Chapter 4 of the US Internal Revenue Code ' +
                '(which obliges non-US financial institutions to identify customers that are US taxpayers, ' +
                'their beneficiaries, and/or persons directly or indirectly controlling thereof, and transfer ' +
                'information regarding the funds on their accounts to the Internal Revenue Service), the Bank ' +
                'registered with the Internal Revenue Service (IRS).',
            clarification: 'Bank 131 JSC was registered as Participating Foreign Financial Institution (PFFI) ' +
                'and received a Global Intermediary Identification Number (GIIN): 4NB0VB.99999.SL643. ' +
                'The main purpose of FATCA is combating tax avoidance in the US jurisdiction by US taxpayers, ' +
                'concerning their incomes generated through non-US financial institutions.',
            theMainGoal: 'Since January 9, 2020, the Bank has been collecting information that allows ' +
                'identifying the affiliation of a person that resorted to the Bank for business purposes, ' +
                'to persons subject to the foreign country`s legislation on taxation of foreign accounts.<br/>' +
                '<br/>' +
                'When concluding an agreement on any service, you need to fill out the Bank\'s questionnaire containing ' +
                'supplementary FATCA information (the Questionnaire). Also, to confirm the customer\'s tax residence, ' +
                'the Bank\'s employee is entitled to ask specification questions and ask to fill out the Self-Certification Form:',
            taxResidentStatusForAnIndividual: {
                title: 'SELF-CERTIFICATION FORM FOR INDIVIDUALS, PRIVATE-PRACTICE PROFESSIONALS, AND SELF-EMPLOYED',
                link: '/legal/en/PERSONAL_SELF-CERTIFICATION_FORM(CRS)(en).doc'
            },
            taxResidentStatusOfALegalEntity: {
                title: 'FATCA SELF-CERTIFICATION FORM FOR LEGAL ENTITIES & FOREIGN UNINCORPORATED ENTITIES',
                link: '/legal/en/SELF-CERTIFICATION_FORM_OF_LEGAL-ENTITY(CRS)(en).doc'
            },
            footnote: [
                {
                    text: 'Please note that the Bank does not consult on the FATCA application. In case of any ' +
                        'questions, please resort to a professional tax advisor. Also, in case of any ' +
                        'questions regarding the essence and application of FATCA, please resort to the website ' +
                        'of the Internal Revenue Service: <a href="https://www.irs.gov/" target="_blank">https://www.irs.gov/</a>'
                }
            ],
            informationForClients: 'Information for Individual Customers',
            additionalDocuments: 'The Bank is entitled to require you to provide the following supplementary documents based on what you specify in the Questionnaire:',
            additionalDocumentsFootnote: [
                {
                    text: 'You are a US citizen/US taxpayer. You need to provide the filled Form W-9 (please find the form on the website of the Internal Revenue Service): ' +
                        '<a href="http://www.irs.gov/pub/irs-pdf/fw9.pdf" target="_blank">http://www.irs.gov/pub/irs-pdf/fw9.pdf</a>).',
                    numbering: '1.'
                },
                {
                    text: 'You were born in the US but you are not a US citizen. You need to provide the following:',
                    numbering: '2.'
                },
            ],
            subAdditionalDocumentsFootnote: [
                {
                    text: 'DS 4083 — Certificate of Loss of Nationality of the United States of the Bureau of Consular Affairs of the United States Department of State',
                    numbering: 'a.'
                },
                {
                    text: 'pleadings on no nationality of the United States (e.g. a reason why you did not obtain nationality after birth).',
                    numbering: 'b.'
                },
            ],
            legalEntities: 'Information for Legal Entities',
            legalEntitiesDescription: 'The Bank is entitled to require you to provide the following supplementary ' +
                'documents based on what you specify in the Questionnaire: Forms W-9 and W-8 and other documents.',
            legalEntitiesLink: [
                {
                    title: 'Form W-8BEN-E',
                    link: W_8BEN_E
                },
                {
                    title: 'Form W-8IMY',
                    link: W_8IMY
                },
                {
                    title: 'Criteria for Recognizing Clients as Foreign Taxpayers. Methods for Obtaining Required Information from Clients',
                    link: '/legal/en/Grounds_for_classification_as_foreign_taxpayers(en).doc'
                },
                {
                    title: 'CONSENT/ WAIVER ON DISCLOSURE OF INFORMATION TO FOREIGN TAX AUTHORITIES AND RUSSIAN AUTHORIZED BODIES',
                    link: '/legal/en/INFORMATION_PERMIT(en).docx'
                },
                {
                    title: 'Glossary',
                    link: glossary
                },
            ]
        },
        crsCompliance: {
            information: '<span class="bold">Common Reporting Standard (CRS)</span> is an automated financial account ' +
                'data exchange standard developed by the Organisation for Economic Co-operation and Development.<br/>' +
                '<br/>' +
                '<span class="bold">CRS</span> is an international analog of FATCA aimed at improving taxation transparency and preventing global tax avoidance.<br/>' +
                '<br/>' +
                'In May 2016, Russia confirmed its engagement in CRS compliance. Per Federal Law of Russia No. ' +
                '340-FZ dd. November 27, 2017 "On amendments to Part 1 of the Tax Code of Russia due to the ' +
                'international automated data and document exchange regarding international groups", persons ' +
                'concluding (or those having concluded) a financial service agreement with the Bank are obliged ' +
                'to provide the Bank with tax residence information regarding themselves, their beneficiaries, ' +
                'and/or persons directly or indirectly controlling thereof.<br/>' +
                '<br/>' +
                'The Tax Code of Russia contains some provisions according to which Russian banks are obliged to ' +
                'identify the customers, beneficiaries, and/or persons directly or indirectly controlling thereof, ' +
                'who are tax residents of foreign countries (jurisdictions), and provide information on them and ' +
                'their accounts to the Federal Tax Service of Russia.<br/>' +
                '<br/>' +
                'In compliance with the Tax Code of Russia, customers are obliged to provide tax residence information ' +
                'regarding the aforementioned persons, as required by the Bank.<br/>' +
                '<br/>' +
                'If the customer fails to provide the aforementioned information when concluding a ' +
                'financial service agreement with the Bank, the Bank shall be entitled to:',
            footnote: [
                {
                    text: 'decline such an agreement',
                    numbering: '—'
                },
                {
                    text: 'refuse to execute transactions on behalf or by order of the customer under the financial service agreement',
                    numbering: '—'
                },
                {
                    text: 'unilaterally terminate the financial service agreement having notified the customer of such an event no later than in one business day following the day of making such a decision',
                    numbering: '—'
                },
            ],
            secondInformation: 'The Bank is entitled to unilaterally terminate the financial service agreement ' +
                'concluded with the Customer if the Bank—when taking measures as prescribed in Clause 1 of ' +
                'Article 142.4 of Chapter 20.1 of the Tax Code of Russia—identifies unreliability or ' +
                'incompleteness of information provided by the customer or finds a conflict between ' +
                'information provided by the customer and information available to the Bank (including ' +
                'information from public sources).<br/>' +
                '<br/>' +
                'For compliance with Russian law, Bank 131 JSC shall find out whether the customer, their beneficiary, ' +
                'and/or persons directly or indirectly controlling thereof, are a tax resident (with specification of ' +
                'the country of tax residence). Bank 131 JSC can identify the status of a tax resident based on ' +
                'information available to Bank 131 JSC. But, the Bank is entitled to require the customer to fill ' +
                'and provide the appropriate tax residence confirmation Forms.<br/>' +
                '<br/>' +
                'Bank 131 JSC does not consult on tax residence identification per CRS requirements. To find ' +
                'information on this matter, you can read tax residence information on the website of the ' +
                'Organisation for Economic Co-operation and Development:<br/> <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/#d.en.347760" target="_blank">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/#d.en.347760</a><br/>' +
                '<br/>' +
                'To confirm the tax residence, the Bank\'s employee is entitled to ask specification questions and ask the customer to fill out the Self-Certification form:',
            informationLink: [
                {
                    title: 'TAXPAYER STATUS SELF-CERTIFICATION FORM FOR INDIVIDUALS, PRIVATE-PRACTICE PROFESSIONALS, AND SELF-EMPLOYED',
                    link: '/legal/en/PERSONAL_SELF-CERTIFICATION_FORM(CRS)(en).doc'
                },
                {
                    title: 'TAXPAYER STATUS SELF-CERTIFICATION FORM (FOR LEGAL ENTITIES INCLUDING UNINCORPORATED FOREIGN ENTITIES)',
                    link: '/legal/en/SELF-CERTIFICATION_FORM_OF_LEGAL-ENTITY(CRS)(en).doc'
                },
            ],
            legalEntities: 'Supplementary Information',
            legalEntitiesDescription: 'TIN: <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers" target="_blank">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers</a><br/>' +
                '<br/>' +
                'Tax residence in foreign countries: <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/#d.en.347760" target="_blank">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/#d.en.347760</a><br/>' +
                '<br/>' +
                'Countries providing investment residence:  <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/residence-citizenship-by-investment/" target="_blank">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/residence-citizenship-by-investment/</a><br/>' +
                '<br/>' +
                'The Tax Service of Russia opened a section of the corporate website, devoted to the international automated information exchange, where documents and frequently asked questions are published:  <a href="https://340fzreport.nalog.ru/" target="_blank">https://340fzreport.nalog.ru/</a>'
        },
        bpa: {
             rectangle: [
                 {
                     title: 'FULL NAME',
                     description: 'Limited Liability Company "Akkord"'
                 },{
                     title: 'LEGAL ADDRESS',
                     description: '129626, Moscow, Grafsky lane, 14B, floor 2, room 24'
                 },{
                     title: 'TIN',
                     description: '9717091209'
                 },{
                     title: 'RRC',
                     description: '771701001'
                 },{
                     title: 'STATE REGISTRATION NUMBER',
                     description: '1207700137171'
                 },{
                     title: 'BANK DETAILS',
                     description: 'PJSC Promsvyazbank <br />Account 40702810602000080159 <br />Correspondent account 30101810300000000760 <br />BIC 047888760'
                 },{
                     title: 'WEBSITE',
                     description: '<a href="https://instant-pay.ru" target="_blank">https://instant-pay.ru</a>'
                 },{
                     title: 'CONTRACT NO.',
                     description: 'ВР-051 от 22.07.2021'
                 },
             ]
         },
         importantUpdates: [
           {
               title: 'Changes in the Board of Directors',
               clarification: {
                   label: '',
                   text: '<b style="display: contents;">Changes in the Board of Directors</b><br />'+
                        'On May 5, 2022, D. Eremeev, S. Eremeev, and N. Eremeev were removed from the board '+
                        'of directors of Bank 131, LLC. On May 5, 2022, new members of the board of directors '+
                        'of Bank 131, LLC was elected. The authority of the previously elected members '+
                        'of the board (D. Eremeev, S. Eremeev, and N. Eremeev) has been terminated.'
               }
           }
         ],
    },

    listMenu: {
        aboutBank: {
            title: 'Bank Details',
            subMenu: [
                {
                    title: 'Bank Details',
                    query: 'requisite'
                },
                {
                    title: 'Offices of JSC Bank 131',
                    query: 'offices',
                },
            ]
        },
        legalInformation: {
            title: 'Legal information',
            subMenu: [
                {
                    title: 'Central Bank license',
                    query: 'centralBankLicense'
                },
                {
                    title: 'PCI DSS certified',
                    query: 'pciDSSCertified'
                },
                {
                    title: 'PD protection',
                    query: 'pdProtection'
                },
                {
                    title: 'FATCA Compliance',
                    query: 'fatcaCompliance'
                },
                {
                    title: 'CRS Compliance',
                    query: 'crsCompliance'
                }
            ]
        },
        financialStatements: {
            title: 'Financial statements',
            subMenu: [
                {
                    title: '2021',
                    query: '2021'
                },                {
                    title: '2020',
                    query: '2020'
                },
                {
                    title: '2019',
                    query: '2019'
                }
            ]
        },
        otherReports: {
            title: 'Other information',
            subMenu: [
                {
                    title: 'OSMS 2020 Report',
                    query: 'osms2020Report'
                },
                {
                    title: 'List of BPA',
                    query: 'bpa'
                },
                {
                    title: 'Updates',
                    query: 'importantUpdates'
                },
                {
                    title: 'MirPay',
                    link: '/mirpay',
                }
            ]
        },
    },

    requisite: {
        title: 'Bank Details'
    },
    offices: {
        title: 'Offices of JSC Bank 131',
    },
    bankManagement: {
        title: 'Management'
    },
    centralBankLicense: {
        title: 'Central Bank license'
    },
    pciDSSCertified: {
        title: 'PCI DSS certified'
    },
    pdProtection: {
        title: 'PD protection'
    },
    fatcaCompliance: {
        title: 'FATCA Compliance'
    },
    crsCompliance: {
        title: 'CRS Compliance'
    },
    2021: {
        title: 'Financial statements for 2021'
    },
    2020: {
        title: 'Financial statements for 2020'
    },
    2019: {
        title: 'Financial statements for 2019'
    },
    osms2020Report: {
        title: 'OSMS 2020 Report'
    },
    bpa: {
        title: 'Bank payment aggregator'
    },
    importantUpdates: {
        title: 'Updates'
    },


}
